import axiosInstance from '@/api/http';
import { IResponse } from '@/api/IResponse';
import CreateRoleModel from '@/models/roles/createRoleModel';
import UpdateRoleModel from '@/models/roles/updateRoleModel';

export default class RoleService {
/**
 * @description: 查询角色
 * @return {Promise}
 */
  static getPageAll = (page: number, size: number, accountType: number, name?: string): Promise<IResponse> => {
    let url = `role?page=${page}&size=${size}`;
    if (name) url += `&name=${name}`;
    if (accountType >= 0) url += `&accountType=${accountType}`;
    return axiosInstance.get(url).then((res) => res.data);
  }

  /**
 * @description: 查询角色
 * @return {Promise}
 */
   static getAll = (): Promise<IResponse> => axiosInstance.get('role/roleallquery').then((res) => res.data)

/**
* @description: 新增角色
* @param {CreateRoleModel} params
* @return {Promise}
*/
static create = (params: CreateRoleModel): Promise<IResponse> => axiosInstance.post('role', params).then((res) => res.data);

/**
* @description: 查询指定accessGroupId的信息
* @return {Promise}
*/
static get = (accessGroupId :string): Promise<IResponse> => axiosInstance.get(`role/${accessGroupId}`).then((res) => res.data);

/**
 * @description: 删除指定accessGroupId的信息
 * @return {Promise}
 */
static delete = (accessGroupId :string): Promise<IResponse> => axiosInstance.delete(`role/${accessGroupId}`).then((res) => res.data);

/**
* @description: 修改指定accessGroupId的信息
* @return {Promise}
*/
  static update = (accessGroupId: string, params: UpdateRoleModel): Promise<IResponse> => axiosInstance.put(`role/${accessGroupId}`, params).then((res) => res.data);

  /**
* @description: 修改指定accessGroupId的状态
* @return {Promise}
*/
  static updateStatus = (accessGroupId: string, isActive: boolean): Promise<IResponse> => axiosInstance.put(`role/updaterolestatus/${accessGroupId}`, { isActive }).then((res) => res.data);

/**
* @description: 查询全部的权限码
* @return {Promise}
*/
static getAccessRight = (): Promise<IResponse> => axiosInstance.get('accessright').then((res) => res.data);
}
